import {
  FindParentElement,
  GetInputValue,
  SetContentToElement,
  SetAttribute,
  RemoveAttribute,
} from "@/libs/cart/utility";
import {
  CartOrderApiFactory,
  CartChangeResult,
  CartOrderRequestType,
  OrderErrorItem,
} from "@/libs/api/cart/types";
import {
  FindChangedCartOrderItem,
  FilterCartOrderItem,
  _ToggleItemActionElements,
  Omit,
} from "@/libs/cart/order/utility/types";
import { MakeOptions } from "@/libs/cart/item/types";
import { _InvokeDialogStepper, _ShowDialog } from "@/libs/cart/dialog/types";

/**
 * 商品のステータス
 */
export enum CartOrderItemStatus {
  /**
   * 数量変更
   */
  Changed = "isChanged",
  /**
   * 削除
   */
  Canceled = "isCanceled",
  /**
   * 通常
   */
  Default = "",
}

export type InvokeChangeCartOrderItemQuantities = (
  findParentElement: FindParentElement,
  getInputValue: GetInputValue,
  setContentToElement: SetContentToElement,
  makeOptions: MakeOptions,
  setAttribute: SetAttribute,
  removeAttribute: RemoveAttribute,
  updateCartOrderItems: UpdateCartOrderItems,
  showErrorDialog: _ShowErrorDialog,
  findChangedCartOrderItem: FindChangedCartOrderItem,
  invokeDialogStepper: _InvokeDialogStepper,
  itemSelector: string,
  orderNumberSelector: string,
  deleteSelector: string
) => (event: JQuery.Event) => Promise<void>;

export type InvokeDeleteCartOrderItem = (
  findParentElement: FindParentElement,
  getInputValue: GetInputValue,
  setAttribute: SetAttribute,
  removeAttribute: RemoveAttribute,
  updateCartOrderItems: UpdateCartOrderItems,
  showErrorDialog: _ShowErrorDialog,
  findChangedCartOrderItem: FindChangedCartOrderItem,
  toggleItemActionElements: _ToggleItemActionElements,
  invokeDialogStepper: _InvokeDialogStepper,
  itemSelector: string,
  orderNumberSelector: string,
  selectSelector: string,
  reservedClass: string,
  nameSelector: string
) => (event: JQuery.Event) => Promise<void>;

export type InvokeBulkDeleteCartOrderItem = (
  filterCartOrderItem: FilterCartOrderItem,
  getInputValue: GetInputValue,
  updateCartOrderItems: UpdateCartOrderItems,
  setAttribute: SetAttribute,
  removeAttribute: RemoveAttribute,
  showErrorDialog: _ShowErrorDialog,
  toggleItemActionElements: _ToggleItemActionElements,
  invokeDialogStepper: _InvokeDialogStepper,
  hideAllDialogs: () => void,
  omit: Omit,
  itemSelector: string,
  orderNumberSelector: string,
  deleteSelector: string,
  reservedClass: string,
  nameSelector: string,
  selector: string,
  filterExpr: string
) => (event: JQuery.Event) => void;

export type InvokeRestoreCartOrderItem = (
  findParentElement: FindParentElement,
  getInputValue: GetInputValue,
  setContentToElement: SetContentToElement,
  makeOptions: MakeOptions,
  setAttribute: SetAttribute,
  updateCartOrderItems: UpdateCartOrderItems,
  showErrorDialog: _ShowErrorDialog,
  findChangedCartOrderItem: FindChangedCartOrderItem,
  toggleItemActionElements: _ToggleItemActionElements,
  itemSelector: string,
  orderNumberSelector: string,
  selectSelector: string
) => (event: JQuery.Event) => Promise<void>;

export type InvokeBulkRestoreCartOrderItem = (
  filterCartOrderItem: FilterCartOrderItem,
  getInputValue: GetInputValue,
  setContentToElement: SetContentToElement,
  makeOptions: MakeOptions,
  updateCartOrderItems: UpdateCartOrderItems,
  setAttribute: SetAttribute,
  showErrorDialog: _ShowErrorDialog,
  toggleItemActionElements: _ToggleItemActionElements,
  hideAllDialogs: () => void,
  itemSelector: string,
  orderNumberSelector: string,
  restoreSelector: string,
  selector: string,
  filterExpr: string,
  selectSelector: string
) => (event: JQuery.Event) => void;

export type _UpdateCartOrderItems = (
  api: CartOrderApiFactory
) => UpdateCartOrderItems;

export type UpdateCartOrderItems = (
  mode: CartOrderRequestType,
  orderNum: string,
  items: any
) => Promise<CartChangeResult>;

export type _ShowErrorDialog = (errItems: OrderErrorItem[]) => void;

export type ShowErrorDialog = (
  showDialog: _ShowDialog,
  setAttribute: SetAttribute,
  removeAttribute: RemoveAttribute,
  itemSelector: string,
  selectSelector: string,
  restoreSelector: string,
  deleteSelector: string
) => _ShowErrorDialog;
